import React, { useContext } from 'react';
import MUITablePagination from '@material-ui/core/TablePagination';
import Typography from '@material-ui/core/Typography';
import { TableCell } from '@material-ui/core';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import { makeStyles } from '@material-ui/styles';
import { LocaleContext } from '@tecsinapse/ui-kit';
import { paginationOptions } from '../utils/propTypes';
var styles = makeStyles(function (theme) {
  return {
    total: {
      color: lighten(theme.palette.text.primary, 0.54),
      width: '100%',
      textAlign: 'right'
    }
  };
});

var onChangeRowsPerPage = function onChangeRowsPerPage(onChangePageProp) {
  return function (event) {
    onChangePageProp(event.target.value, 0);
  };
};

var onChangePage = function onChangePage(onChangePageProp, rowsPerPage) {
  return function (event, page) {
    onChangePageProp(rowsPerPage, page);
  };
};

var Pagination = function Pagination(_ref) {
  var rowsPerPageOptions = _ref.rowsPerPageOptions,
      rowsPerPage = _ref.rowsPerPage,
      page = _ref.page,
      rowCount = _ref.rowCount,
      pagination = _ref.pagination,
      onChangePageProp = _ref.onChangePage,
      tableColumns = _ref.tableColumns;
  var classes = styles();

  var _useContext = useContext(LocaleContext),
      _useContext$Table = _useContext.Table,
      labelRowsPerPage = _useContext$Table.labelRowsPerPage,
      labelDisplayedRows = _useContext$Table.labelDisplayedRows;

  if (!pagination) {
    var align = {
      textAlign: 'end'
    };
    return /*#__PURE__*/React.createElement(TableCell, {
      colSpan: tableColumns.length,
      style: align
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      className: classes.total
    }, "Total: ", rowCount));
  }

  return /*#__PURE__*/React.createElement(MUITablePagination, {
    labelDisplayedRows: labelDisplayedRows,
    rowsPerPageOptions: rowsPerPageOptions,
    labelRowsPerPage: labelRowsPerPage,
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: onChangeRowsPerPage(onChangePageProp, rowsPerPage),
    page: page,
    onChangePage: onChangePage(onChangePageProp, rowsPerPage),
    count: rowCount
  });
};

Pagination.defaultProps = {
  pagination: false,
  rowsPerPageOptions: [5, 15, 30],
  rowsPerPage: 15,
  page: 0,
  rowCount: null
};
Pagination.propTypes = paginationOptions;
export default Pagination;